import React from 'react';
import memoize from 'memoize-one';
import { ApprovementStatus, BasicActionBtns, DatatableEmployeeName, DatatableHourMinute } from '../../components';

const columns = memoize(clickHandler => [
  {
    name: 'NOMBRE DEL TRABAJADOR',
    selector: 'name',
    cell: item => (
      <DatatableEmployeeName
        item={item.employee}
        tooltipText={item.translated_status === 'Pendiente' ? item.translated_status : ''}
        tooltipClass="dot-danger"
        withDot
        onClick={() => clickHandler(item, 'show')}
      />
    ),
    sortable: true,
    grow: '2'
  },
  {
    name: 'FECHA',
    selector: 'date',
    sortable: true,
    grow: '1'
  },
  {
    name: 'VALOR',
    selector: 'hour_value',
    cell: item => item.translated_hour_value,
    sortable: true,
    grow: '1'
  },
  {
    name: 'HORAS EXTRA',
    selector: 'hours',
    cell: item => <DatatableHourMinute item={item} onClick={() => clickHandler(item, 'show')} />,
    sortable: true,
    grow: '1'
  },
  {
    name: 'ESTADO',
    selector: 'status',
    cell: item => <ApprovementStatus status={item.status} onClick={() => clickHandler(item, 'show')} />,
    center: true,
    sortable: true,
    grow: '1'
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <BasicActionBtns item={item} resource="Overtime" clickHandler={clickHandler} withShow={false} withEdit={false} />
    ),
    ignoreRowClick: true,
    allowOverflow: false,
    button: true,
    grow: '1',
    minWidth: '123px'
  }
]);

export default columns;
